import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { categoryFavoriteEntity } from './category-favorite.models';
import { Action, createReducer, on } from '@ngrx/store';
import * as CategoryFavoriteActions from './category-favorite.actions';

export const CATEGORY_FAVORITES_FEATURE_KEY = 'categoryFavorites';

export interface CategoryFavoritesState extends EntityState<categoryFavoriteEntity> {
  categoryFavorites: categoryFavoriteEntity | null;
  loaded: boolean;
  error?: string | null;
}

export const categoryFavoriteAdapter: EntityAdapter<categoryFavoriteEntity> =
  createEntityAdapter<categoryFavoriteEntity>();

export const initialCategoryFavoritesState: CategoryFavoritesState = categoryFavoriteAdapter.getInitialState({
  categoryFavorites: null,
  loaded: true,
  error: null,
});

const reducer = createReducer(
  initialCategoryFavoritesState,
  on(CategoryFavoriteActions.loadCategoryFavorites, (state) => ({
    ...state,
    loaded: false,
    error: null,
  })),
  on(CategoryFavoriteActions.loadCategoryFavoritesSuccess, (state, { categoryFavorites }) => ({
    ...state,
    categoryFavorites: categoryFavorites,
    loaded: true,
    error: null,
  })),
  on(CategoryFavoriteActions.loadCategoryFavoritesFailure, (state, { error }) => ({
    ...state,
    loaded: true,
    error: error,
  })),
  on(CategoryFavoriteActions.setCategoryFavorite, (state) => ({
    ...state,
    loaded: false,
    error: null,
  })),
  on(CategoryFavoriteActions.setCategoryFavoriteSuccess, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(CategoryFavoriteActions.setCategoryFavoriteFailure, (state, { error }) => ({
    ...state,
    loaded: true,
    error: error,
  })),
  on(CategoryFavoriteActions.deleteCategoryFavorite, (state) => ({
    ...state,
    loaded: false,
    error: null,
  })),
  on(CategoryFavoriteActions.deleteCategoryFavoriteSuccess, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(CategoryFavoriteActions.deleteCategoryFavoriteFailure, (state, { error }) => ({
    ...state,
    loaded: true,
    error: error,
  }))
);

export function categoryFavoritesReducer(state: CategoryFavoritesState | undefined, action: Action) {
  return reducer(state, action);
}
